/**
 * VIBE_CODING_STANDARD
 *
 * -----
 * VERSION_HISTORY:
 * 1.0.0:gemini-1.5-flash (CURRENT) - Initial creation of the VersionBar component.
 * 1.1.0:gemini-1.5-flash (PREV) - Added functionality to fetch and manage the selected working version tag from IndexedDB.
 * 1.2.0:gemini-1.5-flash (PREV-1) - Refactored to use `useVersioningContext` for global state propagation.
 *
 * -----
 * SECURITY_RISK: LOW - This component displays read-only information about the selected data version
 *                      and provides a navigation link. It does not handle sensitive data or perform write operations.
 * INTENT: Provide a persistent visual indicator of the currently active data version tag
 *         and a quick navigation link to the versioning management page.
 * PROMPTER_INSTRUCTIONS: Ensure the styling keeps the bar fixed and unobtrusive.
 *                        Verify the link correctly navigates to the versioning page.
 * LLM_CONFIDENCE: 100% - Standard UI component integrating a hook and a navigation link.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Tag } from 'lucide-react'; // Using Tag icon from lucide-react
import { useVersioningContext } from '../context/VersioningContext.tsx'; // MODIFIED: Import useVersioningContext
import { Spinner } from './ui/spinner.tsx';

const VersionBar: React.FC = () => {
  const { selectedVersionTag, versionSelectionLoading } = useVersioningContext(); // MODIFIED: Use useVersioningContext

  let dvClass = "fixed top-0 left-0 right-0 text-xs p-1 flex items-center justify-center shadow-lg z-50";
  if(selectedVersionTag == '' || selectedVersionTag == null) {
    dvClass += " bg-green-800 text-white";
  } else {
    dvClass += " bg-gray-800 text-white";
  }

  return (
    <div className={dvClass}>
      <span className="mr-2">Data Version:</span>
      {versionSelectionLoading ? (
        <Spinner size="sm" color="white" className="mr-2" />
      ) : (
        <span className="font-semibold mr-4">
          {selectedVersionTag || 'Main'}
        </span>
      )}
      <Link to="/versioning" className="text-blue-300 hover:text-blue-100 flex items-center">
        <Tag className="h-3 w-3 mr-1" />
        Manage Versions
      </Link>
    </div>
  );
};

export default VersionBar;